import _ from 'lodash';
let sendMessage;
let recordEnabled = true;
let postMessageCallbackMap = new Map();
let postAppOrigin = '*';

export class GooroomeeMediaExtension {
    #mode = 'extension';
    #ExtensionFrameOrigin;
    #extensionFrame;
    #extensionFrameUrl;
    #chromeExtensionId = '';
    #chromeExtensionInstallStatus = 'checking';
    #chromeWebStoreDetailURL = 'https://chrome.google.com/webstore/detail/';

    constructor() {
        sendMessage = this.sendExtensionMessage.bind(this);
        this.initMode();

        let old = window.GooroomeeMediaExtension;
        this.noConflict = function(){
            window.GooroomeeMediaExtension = old
            return this;
        }
        window.GooroomeeMediaExtension = this;

        this.initParams();
    }

    initMode() {
        let mode = document.currentScript.getAttribute('mode');
        if (!mode) {
            return ;
        }
        this.setMode(mode);
    }

    initParams() {
        if(!location.search){
            return;
        }

        let params = location.search.substring(1).split('&');
        let extensionId;
        let installBtn;
        params.forEach(function(param){
            let p = param.split('=');
            switch(p[0]){
                case 'origin':
                    window.localStorage.setItem('__grm_m_ext_o', p[1]);
                    break;
                case 'extensionId':
                    extensionId = p[1];
                    window.localStorage.setItem('__grm_m_ext_id', p[1]);
                    break;
                case 'installBtn':
                    if(p[1] == 'true'){
                        installBtn = true;
                    }
                    break;
            }
        });

        if(installBtn){
            this.setChromeExtensionId(extensionId);
            this.setMode('extension');
            document.addEventListener('DOMContentLoaded', (e) => {
                let btn = document.querySelector('.install-btn');
                btn.classList.remove('hidden');
                btn.addEventListener('click', () => {
                    this.installChromeExtension()
                        .then(function(){
                            window.parent.postMessage({
                                api: 'chromeExtensionInstallResult'
                            }, '*');
                        })
                        .catch(function(error){
                            window.parent.postMessage({
                                api: 'chromeExtensionInstallResult',
                                error: error
                            }, '*');
                        });
                });
            });
        }
    }

    getChromeVersion() {
        let version = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return version ? parseInt(version[2], 10) : -1;
    }

    getGooroomeeMeetingAppBrowser() {
        return navigator.userAgent.indexOf('GooroomeeMeetingApp') != -1
            || navigator.userAgent.indexOf('Gooroomee') != -1;
    }

    setExtensionFrameOrigin(frameUrl) {
        this.#ExtensionFrameOrigin = frameUrl;
    }

    getExtensionFrameOrigin() {
        return this.#ExtensionFrameOrigin;
    }

    setExtensionFrameUrl(frameUrl) {
        this.#extensionFrameUrl = frameUrl;
    }

    getExtensionFrameUrl() {
        return this.#extensionFrameUrl;
    }

    setExtensionFrame(extensionFrame) {
        this.#extensionFrame = extensionFrame;
    }

    getExtensionFrame() {
        return this.#extensionFrame;
    }

    sendExtensionMessage(api, data, callback){
        if(typeof(data) === 'function'){
            callback = data;
            data = null;
        }

        var msgData = {
            api: api,
            data: data
        };

        if(!this.isChromeExtensionInstalled()){
            return;
        }

        // eslint-disable-next-line no-undef
        let cr = chrome;
        if(!cr || !cr.runtime){
            // console.warn('chrome runtime not supported :', cr);
            return;
        }
        cr.runtime.sendMessage(
            this.getChromeExtensionId(),
            msgData,
            null,
            callback || (function(){})
        );
    }

    sendPostMessage(api, data, callback){
        if(typeof(data) === 'function'){
            callback = data;
            data = null;
        }

        var msgData = {
            api: api,
            data: data
        };

        if(callback){
            msgData.reqId = Date.now() + '@' + Math.random();
            postMessageCallbackMap.set(msgData.reqId, callback);
        }

        window.parent.postMessage(msgData, postAppOrigin || '*');
    }

    getMode() {
        return this.#mode;
    }

    getChromeExtensionInstallUrl() {
        return this.#chromeWebStoreDetailURL + this.#chromeExtensionId;
    }

    getLink(chromeExtensionId) {
        return document.querySelector('link[rel="chrome-webstore-item"][grm-cext="' + chromeExtensionId + '"]');
    }

    setChromeExtensionId(chromeExtensionId) {
        if (!chromeExtensionId) {
            return Promise.reject('invalid extensionId');
        }

        if (this.getChromeExtensionId() === chromeExtensionId) {
            return this.checkChromeExtensionInstalled();
        }

        let link = this.getLink(chromeExtensionId);
        if (link) {
            try {
                link.remove();
            } catch (e) {
                console.warn('setChromeExtensionId link warn : ', e);
            }
        }

        this.#chromeExtensionId = chromeExtensionId;
        link = this.getLink(this.#chromeExtensionId);
        if (link) {
            return this.checkChromeExtensionInstalled();
        }

        // Create Link
        link = document.createElement('link');
        link.setAttribute('rel', 'chrome-webstore-item');
        link.setAttribute('grm-cext', chromeExtensionId);
        link.setAttribute('href', this.getChromeExtensionInstallUrl());
        document.querySelector('head').appendChild(link);

        link.addEventListener('grm-ext-event', fromChromeExtension);

        this.GrmEvent.setHtmlElement(link);

        this.setChromeExtensionInstallStatus('checking');
        return this.checkChromeExtensionInstalled()
            .then(this.Record.getState)
            .then((result)=>{
               this.GrmEvent.dispatchEvent('record-state-change', result);
            });
    }

    addEventListener(type, listener){
        this.GrmEvent.on(type, listener);
        return this;
    }

    removeEventListener(type, listener){
        this.GrmEvent.off(type, listener);
        return this;
    }

    getChromeExtensionId() {
        return this.#chromeExtensionId;
    }

    getChromeExtensionInstallStatus() {
        return this.#chromeExtensionInstallStatus;
    }

    setChromeExtensionInstallStatus(chromeExtensionInstallStatus) {
        this.#chromeExtensionInstallStatus = chromeExtensionInstallStatus;
    }

    isChromeExtensionInstalled(){
        switch(this.getMode()){
            case 'extension':
                return this.getChromeExtensionInstallStatus() === 'installed-enabled';
            case 'extension-frame-client':
            case 'extension-frame':
            case 'app':
                return true;
        }
        return false;
    }

    checkChromeExtensionInstalled(){
        if(!this.getChromeExtensionId()){
            return Promise.reject('chromeExtensionId-notfound');
        }

        return new Promise((resolve, reject) =>{
            if(this.getMode() === 'extension-frame-client'){
                sendMessage('checkChromeExtensionInstalled', function(error){
                    if(error){
                        this.setChromeExtensionInstallStatus('not-installed');
                        resolve(this.getChromeExtensionInstallStatus());
                    }else{
                        this.setChromeExtensionInstallStatus('installed-enabled');
                        resolve(this.getChromeExtensionInstallStatus());
                    }
                });
                return;
            }

            let img = new Image();
            img.onload = () => {
                this.setChromeExtensionInstallStatus('installed-enabled');
                resolve(this.getChromeExtensionInstallStatus());
            };
            img.onerror = () => {
                this.setChromeExtensionInstallStatus('not-installed');
                resolve(this.getChromeExtensionInstallStatus());
            };
            img.src = 'chrome-extension://' + this.getChromeExtensionId() + '/blank.gif';
        });
    }

    installChromeExtension(reChk){
        let chkSupported = !!navigator.webkitGetUserMedia && !!window.chrome;

        if(!chkSupported){
            return Promise.reject('not-supported');
        }

        if(this.isChromeExtensionInstalled()){
            return Promise.resolve();
        }else if(reChk === true){
            return this.checkChromeExtensionInstalled().then(() => {
                return this.installChromeExtension();
            });
        }

        // eslint-disable-next-line no-undef
        if(!chrome.webstore || !chrome.webstore.install){
            InstallPromise.reject('manual-install-required');
        }else{
            try{
                // eslint-disable-next-line no-undef
                chrome.webstore.install(
                    this.getChromeExtensionInstallUrl(),
                    function() {
                        this.setChromeExtensionInstallStatus('installed-enabled');
                        InstallPromise.resolve();
                    },
                    function(error){
                        if(error === 'User cancelled install'){
                            error = 'user-cancelled-install';
                        }

                        InstallPromise.reject(error);
                    }
                );
            }catch(e){
                if(e.message && e.message.includes('A Chrome Web Store installation is already pending')){
                    console.warn(e);
                }else{
                    console.error(e);
                }
                InstallPromise.reject(e);
            }
        }

        return InstallPromise.promise;
    }

    setMode(mode, options){
        switch(mode){
            case 'extension':
                this.#mode = mode;

                postMessageCallbackMap = null;
                sendMessage = this.sendExtensionMessage.bind(this);
                window.removeEventListener('message', fromPostMessage);
                break;
            case 'extension-frame-client':
                this.#mode = mode;
                sendMessage = sendExtensionFrameMessage.bind(this);

                window.removeEventListener('message', fromExtensionFrameMessage);
                window.addEventListener('message', fromExtensionFrameMessage, false);


                this.setExtensionFrameUrl(options.frameUrl);
                this.setExtensionFrame(document.createElement('iframe'));
                this.getExtensionFrame.addEventListener('load', (e) =>{
                    this.setChromeExtensionId( options.chromeExtensionId );
                    this.getExtensionFrame.addEventListener('load', function(e){
                    }, {once: true});
                    this.getExtensionFrame.src = options.frameUrl;
                }, {once: true});
                this.getExtensionFrame.src = options.frameUrl + '?origin='+location.origin+'&extensionId='+options.chromeExtensionId;
                this.getExtensionFrame.frameBorder = '0';
                this.getExtensionFrame.style.display = 'none';
                document.body.appendChild(this.getExtensionFrame());
                break;
            case 'extension-frame':
                this.#mode = mode;
                this.setExtensionFrameOrigin(window.localStorage.getItem('__grm_m_ext_o'));
                this.setChromeExtensionId(window.localStorage.getItem('__grm_m_ext_id'));
                window.localStorage.removeItem('__grm_m_ext_o');
                window.localStorage.removeItem('__grm_m_ext_id');

                if(!this.getExtensionFrameOrigin){
                    return;
                }

                sendMessage = this.sendExtensionMessage.bind(this);

                window.removeEventListener('message', fromExtensionFrameMessage);
                window.addEventListener('message', fromExtensionFrameMessage, false);
                break;
            case 'app':
                this.#mode = mode;

                postMessageCallbackMap = new Map();
                sendMessage = this.sendPostMessage.bind(this);
                window.addEventListener('message', fromPostMessage, false);

                //let origin = location.protocol + '//' + location.hostname;
                sendMessage('reg-client', (data, e) => {
                    postAppOrigin = e.origin;
                });
                break;
        }

        this.Record.manualChangeState();
    }



    FileDownloads = {
        map: new Map(),
        add: function(reqId, data){
            this.map.set(reqId, data);
        },
        get: function(reqId){
            return this.map.get(reqId);
        },
        trigger: function(eventType, data){
            var fd = this.get(data.reqId);
            if(!fd){
                console.error('grm fileDownloads file download data not found :', eventType, data);
                return;
            }

            var listener = null;
            switch(eventType){
                case 'file-download-error':
                    this.map.delete(data.reqId);
                    fd.listener.onerror && fd.listener.onerror(data);
                    break;
                case 'file-download-start':
                    fd.listener.onstart && fd.listener.onstart(data);
                    break;
                case 'file-download-progress':
                    fd.listener.onprogress && fd.listener.onprogress(data);
                    break;
                case 'file-download-complete':
                    this.map.delete(data.reqId);
                    fd.listener.oncomplete && fd.listener.oncomplete(data);
                    break;
                default:
                    console.error('grm fileDownloads unknown eventType :', eventType, data);
                    break;
            }
        }
    };

    Record = {
        setEnable: function(enable){
            recordEnabled = !!enable;
        },
        checkRecordPermission: function(){
            return reqSimpleRecordMsg('check-record-permission', function(data, resolve, reject){
                if(data && data.error){
                    reject(data.error);
                }else{
                    resolve();
                }
            });
        },
        getState: function(){
            return reqSimpleRecordMsg('get-record-state', function(data, resolve, reject){
                if(!data) return;
                resolve(data);
            });
        },
        start: function(options){
            let timer;
            return new Promise((resolve, reject) => {
                const to = 500;
                const manualRecordState = (loop) => {
                    if(loop*to > 5000) return;
                    console.log('record receive timeout: loop[%s]', loop);
                    this.getState().then(result => {
                        console.log('get record state(manual):', result);
                        if(result.state === 'inactive'){
                            timer = setTimeout(manualRecordState.bind(this, (loop||1)+1), to);
                            return;
                        }
                        gooroomeeMediaExtension.GrmEvent.dispatchEvent('record-state-change', result);
                    });
                }
                timer = setTimeout(manualRecordState.bind(this, 1), to);
                gooroomeeMediaExtension.GrmEvent.on('record-state-change', e => {
                    clearTimeout(timer);
                }, {once: true});

                const api = 'record-start';
                sendMessage(api, options, function(data){
                    if(data && data.error){
                        console.error('fail : api[%s], error[%s]', api, data.error);
                        reject(data.error);
                        return;
                    }
                    resolve();
                });
            });
        },
        pause: function(){
            reqSimpleRecordMsg('record-pause');
            return this.manualChangeState();
        },
        resume: function(){
            reqSimpleRecordMsg('record-resume')
            return this.manualChangeState();
        },
        stop: function(){
            reqSimpleRecordMsg('record-stop')

            let timer;
            const to = 500;
            const manualRecordState = (loop) => {
                if(loop*to > 5000) return;
                console.log('record receive timeout: loop[%s]', loop);
                this.getState().then(result => {
                    console.log('get record state(manual):', result);
                    if(result.state !== 'inactive'){
                        timer = setTimeout(manualRecordState.bind(this, (loop||1)+1), to);
                        return;
                    }
                    gooroomeeMediaExtension.GrmEvent.dispatchEvent('record-state-change', result);
                });
            }
            timer = setTimeout(manualRecordState.bind(this, 1), to);
            gooroomeeMediaExtension.GrmEvent.on('record-state-change', e => {
                clearTimeout(timer);
            }, {once: true});
            return Promise.resolve();
        },
        muteAudioInput: function(mute){
            sendMessage('mute-audio-input', {mute: mute});
        },
        saveFile: function(filename){
            sendMessage('save-record-file', {filename: filename});
        },
        saveFileByUrl: function(url, filename){
            sendMessage('save-record-file-by-url', {url: url, filename: filename});
        },
        createOptionsPageTab: function(){
            sendMessage('create-devices-options-tab');
        },
        webrtcOffer: function(data){
            sendMessage('webrtc-offer', data);
        },
        webrtcIceCandidate: function(data){
            sendMessage('webrtc-icecandidate', data);
        },
        webrtcSessionClosed: function(data){
            sendMessage('webrtc-session-closed', data);
        }
    }

    GrmEvent = {
        data: {
            el: null,
            eventMap: new Map()
        },
        setHtmlElement: function(el){
            this.data.el = el;

            for(var obj of this.data.eventMap){
                var type = obj[0];
                obj[1].forEach(function(listener){
                    el.addEventListener(type, listener, listener.options);
                });
            }
        },
        on: function(type, listener, options){
            var list = this.data.eventMap.get(type);
            if(!list){
                list = [];
                this.data.eventMap.set(type, list);
            }
            if(options) listener.options;
            list.push(listener);

            if(this.data.el){
                this.data.el.addEventListener(type, listener, options);
            }
        },
        off: function(type, listener){
            let el = this.data.el;
            if(listener){
                if(el){
                    el.removeEventListener(type, listener);
                }
                let list = this.data.eventMap.get(type);
                if(!list) return;
                list.splice(list.indexOf(listener), 1);
                if(list.length === 0){
                    this.data.eventMap.delete(type);
                }
            }else{
                let list = this.data.eventMap.get(type);
                this.data.eventMap.delete(type);
                if(list){
                    list.forEach(function(listener){
                        el.removeEventListener(type, listener);
                    });
                }
            }
        },
        dispatchEvent: function(type, data){
            if(!this.data || !this.data.el) return;

            if(typeof(type) === 'object'){
                data = type.data;
                type = type.type;
            }

			      console.log('# gme dispatchEvent :', gooroomeeMediaExtension.getMode(), type, data);

            if(gooroomeeMediaExtension.getMode() === 'extension-frame'){
                //sendExtensionFrameMessage('record-state-change', data);
                return;
            }

            const e = new CustomEvent(type, {
                detail: data,
                bubbles: true, cancelable: true
            });
            e.data = data;
            this.data.el.dispatchEvent(e);
        }
    }

    GrmExtEvent = {
        'grmExt-contentScript-Loaded': function(msg) {
            this.GrmEvent.dispatchEvent({
                type: 'extension-loaded'
            });
        },
        'record-enable-check': function(msg){
            if(recordEnabled){
                //sendExtensionMessage('record-enabled');
                sendMessage('record-enabled');
            }
        },
//		'record-state-change': function(msg){
//			GrmEvent.dispatchEvent(msg);
//		},
//		'req-record-start-with-server': function(msg){
//			GrmEvent.dispatchEvent(msg);
//		},
//		'record-server-send-remain-start': function(msg){
//			GrmEvent.dispatchEvent(msg);
//		},
//		'record-server-send-remain-progress': function(msg){
//			GrmEvent.dispatchEvent(msg);
//		}
        'file-download-error': function(msg){
            //FileDownloads.trigger(msg.type, msg.data);
        },
        'file-download-start': function(msg){
            //FileDownloads.trigger(msg.type, msg.data);
        },
        'file-download-progress': function(msg){
            //FileDownloads.trigger(msg.type, msg.data);
        },
        'file-download-complete': function(msg){
            //FileDownloads.trigger(msg.type, msg.data);
        }
    }
}

let InstallPromise = {};
InstallPromise.promise = (new Promise(function(resolve, reject){
    InstallPromise.resolve = resolve;
    InstallPromise.reject = reject;
}));

let reqSimpleRecordMsg = function(api, callback){
    return new Promise(function(resolve, reject){
        sendMessage(api, function(data){
            if(callback){
                callback(data, resolve, reject);
                return;
            }
            if(data && data.error){
                console.error('fail :', api, data.error);
                reject(data.error);
                return;
            }
            resolve();
        });
    });
}

function fromChromeExtension(e) {
    let msg = e.data || e.detail;
    if(!msg){
        msg = JSON.parse(this.getAttribute('data-grmmsg'));
        this.removeAttribute('data-grmmsg');
    }

    receiveMessage(msg);
}

function fromPostMessage(e){

    if(e.origin.indexOf('chrome-extension://') !== 0 && e.origin.indexOf('gooroomee.com') === -1){
        return;
    }

    let msg = e.data || e.detail;
    if(msg.type === 'res' && msg.reqId){
        var callback = postMessageCallbackMap.get(msg.reqId);
        if(callback){
            postMessageCallbackMap.delete(msg.reqId);
            callback(msg.data, e);
            return;
        }
    }

    msg.type = msg.api;
    receiveMessage(msg);
}

function receiveMessage(msg){

    if(!msg){
        console.warn('[gme] msg is null');
        return;
    }

    let func = gooroomeeMediaExtension.GrmExtEvent[msg.type];
    if(!func){
        gooroomeeMediaExtension.GrmEvent.dispatchEvent(msg);
        return;
    }
    func(msg);
}

// extension-frame S -----------------------------------------------------------------
let _ext_frame_msg_id = 0;
function sendExtensionFrameMessage(api, data, callback){
    if(typeof(data) === 'function'){
        callback = data;
        data = null;
    }

    var msgData = {
        api: api,
        data: data
    };

    if(callback){
        msgData.type = 'req';
        msgData.reqId = _ext_frame_msg_id++;
        msgData.callback = true;

        postMessageCallbackMap.set(msgData.reqId, callback);
    }

    switch(gooroomeeMediaExtension.getMode()){
        case 'extension-frame-client':
            gooroomeeMediaExtension.getExtensionFrame().contentWindow.postMessage(msgData, '*');
            break;
        case 'extension-frame':
            window.parent.postMessage(msgData, '*');
            break;
    }
}

function fromExtensionFrameMessage(e){
    if(e.origin === location.origin){
        return;
    }

    let msg = e.data;
    if(msg.type === 'res' && msg.reqId){
        let callback = postMessageCallbackMap.get(msg.reqId);
        if(callback){
            postMessageCallbackMap.delete(msg.reqId);
            callback(msg.data, e);
            return;
        }
    }

    let callback;
    if(msg.callback){
        callback = function(data){
            let res = {
                type: 'res',
                reqId: msg.reqId,
                data: data
            };

            switch(gooroomeeMediaExtension.getMode()){
                case 'extension-frame-client':
                    window.postMessage(res, '*');
                    break;
                case 'extension-frame':
                    window.parent.postMessage(res, '*');
                    break;
            }
        }
    }

    //console.log('#', Mode, ':', e);
    switch(gooroomeeMediaExtension.getMode()){
        case 'extension-frame-client':
            // TODO
            gooroomeeMediaExtension.GrmEvent.dispatchEvent(msg.api, msg.data);
            break;
        case 'extension-frame':
            switch(msg.api){
                case 'chromeExtensionInstallResult':
                    // TODO
                    if(msg.error){
                        console.error('chromeExtensionInstallResult :', msg.error);
                    }else{
                        console.log('chromeExtensionInstallResult : success');
                    }
                    break;
                case 'checkChromeExtensionInstalled':
                    gooroomeeMediaExtension.checkChromeExtensionInstalled()
                        .then(function(){
                            callback();
                        })
                        .catch(function(e){
                            callback(e);
                        });
                    break;
                default:
                    gooroomeeMediaExtension.sendExtensionMessage(msg.api, msg.data, callback);
                    break;
            }
            break;
    }
}
// extension-frame E -----------------------------------------------------------------

export const gooroomeeMediaExtension = new GooroomeeMediaExtension();